<template>
  <div
    id="reports"
    class="row"
  >
    <div class="col-12">
      <v-col
        v-if="dowloading"
        class="subtitle-1 text-center"
        cols="12"
      > Cargando por favor espere...
      </v-col>
      <v-progress-linear
        indeterminate
        :background-color="backgroundLoadingColor"
        :color="loadingColor"
        height="10"
        v-if="dowloading"
      ></v-progress-linear>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="reset"
        @keydown="form.onKeydown($event)"
      >
        <v-container grid-list-xl>
          <toolbar
            :title="title"
            :loading="form.busy"
            :buttons="buttons"
            @downloadExcel="downloadExcel"
          />
          <v-layout
            :id="ref"
            class="wrap justify-space-around form-body"
          >
            <v-col lg="3" md="6" sm="6" cols="12">
              <v-select
                v-model="form.documentType"
                :items="documentTypes"
                label="Tipo de Documento"
                :rules="[rules.required]"
                required
              />
            </v-col>
            <v-col lg="2" md="6" sm="6" cols="12">
                <v-menu
                  v-model="form.dateMenu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDateFormattedStart"
                      label="Fecha de Emisión Inicio"
                      :rules="[rules.required]"
                      required
                      readonly
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-date-picker
                      :color="themeColor"
                      :max="form.dateMax"
                      v-model="form.dateStart"
                      @input="form.dateMenu1 = false"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" style="padding: 0 !important;">
                    <v-btn
                      block
                      :color="themeColor"
                      dark
                      @click="today('one')"
                    >
                      HOY
                    </v-btn>
                  </v-col>
                </v-menu>
            </v-col>
            <v-col lg="2" md="6" sm="6" cols="12">
              <v-menu
                  v-model="form.dateMenu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDateFormattedEnd"
                      label="Fecha de Emisión Fin"
                      :rules="[rules.required]"
                      required
                      readonly
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-date-picker
                      :color="themeColor"
                      v-model="form.dateEnd"
                      :max="form.dateMax"
                      @input="form.dateMenu2 = false"
                    />
                  </v-col>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-btn
                      block
                      :color="themeColor"
                      dark
                      @click="today('two')"
                    >
                      HOY
                    </v-btn>
                  </v-col>
                </v-menu>
            </v-col>
            <v-col lg="2" md="6" sm="6" cols="12">
              <v-select
                v-model="form.status"
                :items="invoiceStatus"
                label="Estado del Documento"
              />
            </v-col>
            <v-col lg="3" md="3" sm="3" cols="12">
                <v-switch
                  v-model="form.ext"
                  :label="label"
                  :color="themeColor"
                  :input-value="form.ext === 1"
                  @change="toggleActiveAl(form.ext)"
                />
            </v-col>
            <v-col lg="3" md="3" sm="3" cols="12">
                <v-switch
                  v-model="form.typetype"
                  :label="type"
                  :color="themeColor"
                  :input-value="form.typetype === 1"
                  @change="toggleActiveAlType(form.typetype)"
                />
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-select
                v-model="cat_province_id"
                :items="itemsProvince"
                item-value="code"
                item-text="name"
                label="Estado"
                @onchage="getProvincia()"
              />
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12" v-if="this.form.typetype==false">
              <vuetify-select :states="cat_province_id" />
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12" v-if="this.form.typetype==true">
              <v-select
                v-model="form.client_type"
                :items="clientStatus"
                label="Tipo de cliente"
              />
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-text-field
                v-model="form.rucCustomer"
                :rules="[rules.rucLength, rules.rucFormat]"
                label="Nº Identificación Adquiriente"
                maxlength="20"
              />
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
                <v-select
                    :items="tiposLV"
                    :menu-props="{ top: false, offsetY: true }"
                    label="Tipo"
                    v-model="form.tipo"
                    @change="changeTipo"
                />
            </v-col>
            <v-col lg="8" md="8" sm="8" cols="12" v-show="showFilters">
              <vuetify-select-api-code
                style="margin-top: 15px"
                :api="externo.apiExternos"
                :multiple="externo.multiple"
                :placeholder="externo.placeholder"
                @eventupdate="updateExternos"
                :selected="externo.selectedExternos"
                :enterprise_id="form.enterprise_id"
                :showCode="true"
              />
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <vuetify-select-collection
                style="margin-top: 15px"
                ref="refTiposDocumento"
                :collection="tiposDocumento.collection"
                :multiple="tiposDocumento.multiple"
                :placeholder="tiposDocumento.placeholder"
                @eventupdate="updateTiposDocumento"
                :selected="tiposDocumento.selectedTiposDocumento"
                :showCode="false"
              />
            </v-col>
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <v-col>
      <strong>Total de Registros Encontrados: {{ this.totalDocument }}</strong>
      <br/><br/>
      <strong>Total de Archivos a Descargar: {{ this.laps }}</strong>
      <br/><br/>
      <v-progress-linear
        v-model="progress"
        height="25"
        :background-color="backgroundLoadingColor"
        :color="loadingColor"
        dark
        v-if="dowloading"
      >
        <strong>{{ Math.ceil(progress) }}%</strong>
      </v-progress-linear>
    </v-col>

<!--
    <div class="col-12">
      <v-data-table
        v-if="documents != 0"
        :headers="headers"
        :items="documents"
        class="elevation-1"
      >
      <template v-slot:[`item.document_number`]="{ item }">
        {{item.document_number.toString().padStart(8, "0") }}
      </template>
      <template v-slot:item.status="{ item }">
        <div v-if="item.status.indexOf('1') !== -1">
          <v-chip
            :color="getColor(item.status)"
            dark
          >
            ENVIADA
          </v-chip>
        </div>
        <div v-else>
          <v-tooltip bottom color="error">
            <template v-slot:activator="{ on }">
              <v-chip
                :color="getColor(item.status)"
                dark
                v-on="on"
              >
                ANULADA
              </v-chip>
            </template>
            <span><b>Fecha de Anulación:</b> {{ item.dateAnnulment }} </span><br>
            <span><b>Motivo:</b> {{ item.reason }}</span>
          </v-tooltip>
        </div>
      </template>
      </v-data-table>
    </div> -->
  </div>
</template>

<script>
import Form from 'vform';
import moment from 'moment';
import { format, parseISO } from 'date-fns';
import { mask } from 'vue-the-mask';
import { mapGetters } from 'vuex';
import Toolbar from '~/components/Toolbar';
import VuetifySelect from '~/components/VuetifySelect';
import 'vuetify/src/styles/main.sass';
import VuetifySelectApiCode from '~/components/VuetifySelectApiCode';
import VuetifySelectCollection from '~/components/VuetifySelectCollection';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('reportDocument') };
  },
  components: {
    Toolbar,
    VuetifySelect,
    VuetifySelectApiCode,
    VuetifySelectCollection,
  },
  computed: {
    ref() {
      return this.form.id;
    },
    ...mapGetters({
      user: 'auth/user',
      loadingColor: 'theme/loadingColor',
      backgroundLoadingColor: 'theme/backgroundLoadingColor',
      themeColor: 'theme/themeColor',
      navbarColor: 'theme/navbarColor',
    }),
    computedDateFormattedStart() {
        return this.form.dateStart ? moment(this.form.dateStart).format('DD-MM-YYYY') : '';
    },
    computedDateFormattedEnd() {
        return this.form.dateEnd ? format(parseISO(this.form.dateEnd), 'dd-MM-yyyy') : '';
    },
    vamoaver() {
      return (!this.isReadonly || this.client_type === '');
    },
  },
  watch: {
    taxpayer_id(value) {
      if (value !== null) {
        this.client_type = '';
      }
    },
  },
  directives: {
      mask,
    },
  data: () => ({
    title: 'Reporte de Documentos Enviados',
    form: new Form({
      rucContribuyente: '',
      rucSupplier: '',
      rucCustomer: '',
      documentType: '01',
      moneda: null,
      status: '0',
      busy: false,
      dateStart: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateEnd: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateMax: format(parseISO(new Date(new Date().setDate(new Date().getDate() + 3)).toISOString()), 'yyyy-MM-dd'),
      dateMenu1: false,
      dateMenu2: false,
      reason: '',
      dateAnnulment: '',
      typePortal: 'A',
      offset: 0,
      limit: 10000,
      externos: [],
      tipo: 0,
      ext: 0,
      typetype: false,
      client_type: '',
      tiposDocumento: [],
    }),
    label: 'Por Defecto',
    type: 'Nro Identificacion',
    mostrar: 'Por numero',
    progress: 0,
    totalDocument: 0,
    laps: 0,
    // defaultStatus: { text: 'Todas', value: 'all' },
    itemsProvince: [],
    valid: false,
    documentTypes: [
      { value: '01', text: 'Factura' },
      { value: '02', text: 'Nota de Crédito' },
      { value: '03', text: 'Nota de Débito' },
      { value: '04', text: 'Guías de Despacho' },
      { value: '05', text: 'Comprobantes de Retención IVA' },
      { value: '06', text: 'Comprobantes de Retención ISLR' },
    ],
    invoiceStatus: [
      { value: '0', text: 'Todas' },
      { value: '1', text: 'Enviada' },
      { value: '2', text: ' Anulada' },
    ],
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      numeric: (v) => /^([0-9])*$/.test(v) || 'El campo solo permite caracteres numericos.',
      format: (v) => /^(?=.*[0-9])/.test(v) || 'El campo solo permite caracteres numericos.',
      rucLength: (v) => (!v || v.length <= 12) || 'El campo debe tener máximo 12 caracteres.',
      rucFormat: (v) => (!v || /^[V,J,E,P,G]{1}[-][0-9]{1,9}[-][0-9]{1} || [V,J,E,P,G]{1}[-][0-9]{1,9}$/.test(v)) || 'Formato inválido.',
    },
    allHeaders: [
    {
      text: 'Nº Identificación Emisor',
      value: 'emisor_number_id',
      align: 'left',
      sortable: true,
    }, {
      text: 'Nº Identificación Adquiriente',
      value: 'receiver_number_id',
      align: 'left',
      sortable: true,
    },
    {
      text: 'Serie',
      value: 'serie',
      align: 'left',
      sortable: true,
    },
    {
      text: 'Nº Documento',
      value: 'document_number',
      align: 'left',
      sortable: true,
    }, {
      text: 'Nº Control',
      value: 'control_number',
      align: 'left',
      sortable: true,
    }, {
      text: 'Fecha Emisión',
      value: 'issue_date',
      align: 'left',
      sortable: true,
    }, {
      text: 'Fecha Recepción',
      value: 'reception_date',
      align: 'left',
      sortable: true,
    }, {
      text: 'Estado',
      value: 'status',
      align: 'left',
      sortable: true,
    },
    {
      text: 'Observaciones',
      value: 'comments',
      align: 'left',
      sortable: true,
    }],
    documents: 0,
    dowloading: false,
    buttons: [
      // {
      //   id: 'save',
      //   icon: 'mdi-file-find',
      //   name: 'Generar Vista Previa',
      //   event: 'getDocuments',
      //   color: 'blue darken-1',
      // },
      {
        id: 'cancel',
        icon: 'mdi-download',
        name: 'Descargar Excel',
        event: 'downloadExcel',
        color: 'green',
      },
    ],
    clientStatus: [
      { value: '0', text: 'No asignado' },
      { value: '1', text: 'Optativo' },
      { value: '2', text: 'Obligatorio' },
      { value: '3', text: 'Hibrido' },
    ],
    cat_province_id: '',
    isReadonly: false,
    externo: {
      selectedExternos: null,
      apiExternos: '/api/catalogs/other_customers/getexternals',
      multiple: true,
      placeholder: 'Externo',
    },
    tiposLV: [
        { text: 'Todos', value: 0 },
        { text: 'Solo Propios', value: 1 },
        { text: 'Solo terceros', value: 2 },
    ],
    showFilters: false,
    tiposDocumento: {
      selectedTiposDocumento: null,
      collection: [
        { code: 'V', name: 'VENEZOLANO' },
        { code: 'E', name: 'EXTRANJERO' },
        { code: 'J', name: 'JURÍDICO' },
        { code: 'P', name: 'PASAPORTE' },
        { code: 'G', name: 'GUBERNAMENTAL' },
        { code: 'C', name: 'COMUNAL' },
      ],
      multiple: true,
      placeholder: 'Tipos de Documento',
    },
  }),
  async mounted() {
    await this.getProvincia().then((response) => {
      this.itemsProvince = response.data;
      this.cat_province_id = this.itemsProvince[0].code;
    });
  },
  methods: {
    // getDocuments() {
    //   if (this.form.dateEnd < this.form.dateStart) {
    //      this.$store.dispatch('notifications/show', {
    //         message: 'La fecha fin no debe ser menor a la fecha inicio',
    //         type: 'error',
    //       });
    //        this.documents = '';
    //   } else {
    //     this.validateSelect = (this.$store.state.taxpayer.rif === null);
    //     const dateRange = moment(this.form.dateEnd).diff(this.form.dateStart, 'month', true);
    //     if (dateRange > 1) {
    //           this.$store.dispatch('notifications/show', {
    //                 message: 'El rango de consulta no debe ser mayor a un mes',
    //                 type: 'error',
    //             });
    //             this.documents = '';
    //     } else if (this.$store.state.taxpayer.rif === null) {
    //           this.$store.dispatch('notifications/show', {
    //                 message: 'Seleccione el Nº Indentificación del Emisor o Razón Social',
    //                 type: 'error',
    //             });
    //             this.documents = '';
    //     } else {
    //       this.validate();
    //       if (this.$refs.form.validate()) {
    //         this.dowloading = true;
    //         this.form.timeStart = this.form.dateStart.split(' ')[1];
    //         this.form.timeEnd = this.form.dateEnd.split(' ')[1];
    //         this.form.rucSupplier = this.$store.state.taxpayer.rif;
    //         const filteredFields = [];
    //         const url = '/api/reportDocuments'; // Ruta que nos devuelva todos los datos del reporte
    //         this.form.post(url).then((response) => {
    //           this.documents = response.data.items; // creamos array & guardamos el contenido que nos devuelve el response
    //           this.headers = this.allHeaders;

    //           this.headers = this.headers.filter((header) => filteredFields.indexOf(header.text) === -1);
    //           setTimeout(() => { this.dowloading = false; }, 500);
    //         })
    //         .catch(() => {
    //         });
    //       }
    //     }
    //   }
    // },
    toggleActiveAl(extendido) {
      if (extendido) {
        this.label = 'Extendido';
      } else {
        this.label = 'Por Defecto';
      }
    },
    toggleActiveAlType(type) {
      if (type) {
        this.type = 'Por Tipo de cliente';
      } else {
        this.type = 'Numero Identificacion';
      }
      this.form.client_type = '';
    },
    async downloadExcel() {
      if (this.form.dateEnd < this.form.dateStart) {
         this.$store.dispatch('notifications/show', {
                  message: 'La fecha fin no debe ser menor a la fecha inicio',
                  type: 'error',
              });
              this.documents = '';
      } else {
        const dateRange = moment(this.form.dateEnd).diff(this.form.dateStart, 'month', true);
        if (dateRange > 1) {
            this.$store.dispatch('notifications/show', {
                  message: 'El rango de consulta no debe ser mayor a un mes',
                  type: 'error',
              });
               this.documents = '';
        } else if (this.form.typetype === false && this.$store.state.taxpayer.rif === null) {
            this.$store.dispatch('notifications/show', {
                  message: 'Seleccione el Nº Indentificación del Emisor o Razón Social',
                  type: 'error',
              });
               this.documents = '';
        } else {
          this.form.rucSupplier = this.$store.state.taxpayer.rif;
          this.dowloading = true;
          this.form.busy = true;
          this.form.offset = 0;

          const countDocument = await window.axios({
            method: 'post',
            url: '/api/reportDocuments/count',
            data: this.form,
          });

          let titulo = '';
          if (this.form.documentType === '01') {
              titulo = 'Factura';
            } else if (this.form.documentType === '02') {
              titulo = 'Nota de Crédito';
            } else if (this.form.documentType === '03') {
              titulo = 'Nota de Débito';
            } else if (this.form.documentType === '04') {
              titulo = 'Guías de Despacho';
            } else if (this.form.documentType === '05') {
              titulo = 'Comprobantes de Retención IVA';
            } else if (this.form.documentType === '06') {
              titulo = 'Comprobantes de Retención ISLR';
            }
          this.totalDocument = countDocument.data;
          this.laps = 0;
          const laps = this.totalDocument % this.form.limit > 0
                      ? parseInt(this.totalDocument / this.form.limit, 10) + 1
                      : this.totalDocument / this.form.limit;
            for (let i = 0; i < laps; i++) {
              this.laps = laps;
              // eslint-disable-next-line
              const { data } = await this.getReport();
              this.form.offset = (i + 1) * this.form.limit;
              this.downloadFile(data, `Reporte de documentos ${titulo} ${i + 1} de ${laps} Fecha ${format(parseISO(new Date().toISOString()),
              'dd-MM-yyyy')}`);
              const value = (this.totalDocument / laps) * (i + 1);
              this.progress = (value / this.totalDocument) * 100;
            }

            setTimeout(() => {
              this.dowloading = false;
              this.form.busy = false;
              this.progress = 0;
            }, 1000);
        }
      }
    },
    getReport() {
      const url = '/api/reportDocuments';
      return window.axios({
        method: 'post',
        url,
        responseType: 'arraybuffer',
        data: this.form,
      }).catch((e) => {
        // eslint-disable-next-line
        console.log(e);
      });
    },
    downloadFile(response, filename) {
      // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
      // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
      // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      const newBlob = new Blob([response], { type: 'application/vnd.ms-excel' });
      // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename }.xlsx`;
      link.click();
      setTimeout(() => {
        // Para Firefox es necesario retrasar la revocación de ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        if (this.$store.state.taxpayer.rif === null) {
          this.valid = false;
        } else {
          this.valid = true;
        }
      }
    },
    getColor(status) {
        if (status.indexOf('1') !== -1) return 'green';
        return 'red';
    },
    getProvincia() {
        const state = this.user.state != null ? this.user.state : 'Todos';
        const url = `/api/provinces/${state}`;
        return window.axios.get(url);
    },
    updateExternos(externos) {
      this.form.externos = [];
      externos.forEach((item) => {
        this.form.externos.push(item);
      });
    },
    updateTiposDocumento(tiposDocumento) {
      this.form.tiposDocumento = [];
      tiposDocumento.forEach((item) => {
        this.form.tiposDocumento.push(item);
      });
    },
    changeTipo(value) {
      this.form.externos = [];
      if (value === 2) {
        this.showFilters = true;
      } else {
        this.showFilters = false;
      }
    },
    today(menu) {
      if (menu === 'one') {
        this.form.dateStart = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.form.dateMenu1 = false;
      } else {
        this.form.dateEnd = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.form.dateMenu2 = false;
      }
    },
  },
};
</script>
